import * as blocks from './blocks';
import leaves from './leaves';
import { remap } from './utils';

export const blocksByType = remap(blocks, 'type');
export const blocksByRdmdType = remap(blocks, 'rdmdType');
export const leavesByType = remap(leaves, 'type');
